import React from 'react';

import Figure from 'react-bootstrap/Figure';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import {apiBaseUrl} from './Config';

import AdminUpdateAdventureModal from './AdminUpdateAdventureModal';
import AdminDeleteAdventureModal from './AdminDeleteAdventureModal';

import './Adventure.css';

class AdminAdventure extends React.Component {
    constructor(props) {
	super(props);

	this.state = {
	    showUpdateAdventure: false,
	    showDeleteAdventure: false
	};

	this.fetchDocument = this.fetchDocument.bind(this);
	this.handleSuccess = this.handleSuccess.bind(this);
	this.handleError = this.handleError.bind(this);
    }

    fetchDocument(event) {
	const docUrl = apiBaseUrl + "downloadDocument.php/" + this.props.adventure.id;

	var filename = "";

	fetch(docUrl, {
	    headers: {
		"Authorization": "Bearer " + this.props.token
	    }
	})
	    .then(response => {
		if (response.status === 401) {
		    this.props.onAuthError();
		}

		// Get the filename
		const header = response.headers.get('Content-Disposition');
		const parts = header.split(';');
		filename = parts[1].split('=')[1].replaceAll("\"", "");

		return response.blob();
	    })
	    .then(blob => {
		if (blob != null) {
		    var url = window.URL.createObjectURL(blob);
		    var a = document.createElement('a');
		    a.href = url;
		    a.download = filename;
		    document.body.appendChild(a);
		    a.click();
		    a.remove();
		}
	    })
	    .catch((error) => {
		this.setState({
		    error
		});
	    })

	event.preventDefault();
    }
    
    handleSuccess() {
	this.setState({
	    showUpdateAdventure: false,
	    showDeleteAdventure: false
	});

	this.props.onSuccess();
    }
    
    handleError() {
	this.setState({
	    showUpdateAdventure: false,
	    showDeleteAdventure: false
	});

	this.props.onError();
    }
    
    render() {
	var adventure = this.props.adventure;
	
	var thumbUrl = apiBaseUrl + "downloadThumb.php/" + adventure.id;
	
	return (
	    <>
		<Figure className="adventure">
		    <a href="http://" onClick={this.fetchDocument}>
			<Figure.Image src={thumbUrl} />
		    </a>
		    <Figure.Caption>
			<a href="http://" onClick={this.fetchDocument}>
			    {adventure.name}
			</a>
			<br />
			{adventure.year}
			<br />
			<OverlayTrigger overlay={<Tooltip>Uppdatera {adventure.name}</Tooltip>}>
			    <img src="file_edit.png" alt="Uppdatera" className="pointer" onClick={() => this.setState({showUpdateAdventure: true})} />
			</OverlayTrigger>
			&nbsp;&nbsp;&nbsp;&nbsp;
			<OverlayTrigger overlay={<Tooltip>Radera {adventure.name}</Tooltip>}>
			    <img src="file_delete.png" alt="Radera" className="pointer" onClick={() => this.setState({showDeleteAdventure: true})} />
			</OverlayTrigger>
		    </Figure.Caption>
		</Figure>

		<AdminUpdateAdventureModal show={this.state.showUpdateAdventure}
					   adventure={adventure}
					   token={this.props.token}
					   onHide={() => this.setState({showUpdateAdventure: false})}
					   onSuccess={this.handleSuccess}
					   onError={this.handleError}
					   onAuthError={this.props.onAuthError}
		/>
		
		<AdminDeleteAdventureModal show={this.state.showDeleteAdventure}
					   adventure={adventure}
					   token={this.props.token}
					   onHide={() => this.setState({showDeleteAdventure: false})}
					   onSuccess={this.handleSuccess}
					   onError={this.handleError}
					   onAuthError={this.props.onAuthError}
		/>
	    </>
	);
    }
}

export default AdminAdventure;
